// extracted by mini-css-extract-plugin
export default {"button":"button--lzoVF","button__tooltip":"button__tooltip--X2WiD","buttonTooltip":"button__tooltip--X2WiD"};